import { put, call, takeEvery, takeLeading } from "redux-saga/effects";
import request from "utils/api";
import _pick from "lodash/pick";
import Helper from "utils/helpers";
import { safe } from "providers/GeneralProvider/saga";
import {
  getVoucherListRequest,
  getVoucherListSuccess,
  getVoucherListFailure,
  createVoucherRequest,
  createVoucherSuccess,
  createVoucherFailure,
  updateVoucherRequest,
  updateVoucherSuccess,
  updateVoucherFailure,
  deleteVoucherRequest,
  deleteVoucherSuccess,
  deleteVoucherFailure,
  generateCodeRequest,
  generateCodeSuccess,
  generateCodeFailure,
} from "providers/FonehouseVoucher/slice";

function* getVoucherList(action) {
  const params = _pick(action.payload, [
    "page",
    "limit",
    "keyword",
    "status",
    "expired",
  ]);
  const res = yield call(request, "api/fonehouse/voucher", params, {
    method: "GET",
  });
  yield put(getVoucherListSuccess(res?.data || res));
}

function* createVoucher(action) {
  const { meta } = action;
  const params = action.payload;
  const data = yield call(request, "api/fonehouse/voucher", params, {
    method: "POST",
  });
  yield put(createVoucherSuccess(data, meta));
  Helper.toastr(
    `Mã: #${data?.code || ""}`,
    "Tạo voucher thành công",
    "success"
  );
  // Reload list
  yield put(getVoucherListRequest({ page: 1, limit: 10 }));
}

function* updateVoucher(action) {
  const { meta } = action;
  const { id, ...params } = action.payload;
  const data = yield call(request, `api/fonehouse/voucher/${id}`, params, {
    method: "PUT",
  });
  yield put(updateVoucherSuccess(data, meta));
  Helper.toastr("", "Cập nhật voucher thành công", "success");
  yield put(getVoucherListRequest({ page: 1, limit: 10 }));
}

function* deleteVoucher(action) {
  const { id } = action.payload;
  yield call(request, `api/fonehouse/voucher/${id}`, {}, { method: "DELETE" });
  yield put(deleteVoucherSuccess());
  Helper.toastr("", "Xóa voucher thành công", "success");
  yield put(getVoucherListRequest({ page: 1, limit: 10 }));
}

function* generateCode(action) {
  const params = _pick(action.payload, ["length"]);
  const data = yield call(
    request,
    "api/fonehouse/voucher/generate-code",
    params,
    { method: "POST" }
  );
  yield put(generateCodeSuccess(data));
}

function* onError() {
  yield put(getVoucherListFailure());
}

function* onCreateError() {
  yield put(createVoucherFailure());
}

function* onGenerateError() {
  yield put(generateCodeFailure());
}

export default function* watchVoucher() {
  yield takeEvery(
    getVoucherListRequest.type,
    safe(getVoucherList, onError)
  );
  yield takeLeading(
    createVoucherRequest.type,
    safe(createVoucher, onCreateError)
  );
  yield takeLeading(
    updateVoucherRequest.type,
    safe(updateVoucher, onCreateError)
  );
  yield takeLeading(
    deleteVoucherRequest.type,
    safe(deleteVoucher, onError)
  );
  yield takeEvery(
    generateCodeRequest.type,
    safe(generateCode, onGenerateError)
  );
}
